import React, { Component } from "react";
import axios from "axios";
import { v4 as uuid } from "uuid";
import Campaign from "./Campaign";

const config = require("../config.json");

export default class CampaignAdmin extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.convertUnix = this.convertUnix.bind(this);
  }

  state = {
    newCampaign: {
      campaignName: "",
      id: uuid(),
      campaignHidden: false,
      onboardingTextOne: "",
      onboardingTextTwo: "",
      onboardingTextThree: "",
      usersCanCreateTeams: false,
      usersCanCompleteYesterdayActivities: false,
      userCreateTeamsDeadlineHours: 48,
      minUsersOnTeam: 0,
      maxUsersOnTeam: 0,
      campaignMaxKGCO2: 0,
      nextLeagueStart: 0,
      timePeriod: 0,
      timePeriodName: "week",
      weekAmount: 0,
      campaignType: "",
      disableMissedActivitiesPopup: false,
      disableStreaks: false,
      disableQuests: false,
      campaignImage: "",
      activityPacks: { defaultPack: "" },
      quizPacks: { defaultPack: "" },
      amountOfQuizzesPerDay: 0,
      notificationPack: "",
      activityCardsDisabled: false,
      activityListDisabled: false,
      streakRewardPoints: 0,
      streakRewardDayFrequency: 0,
      extraPointsForRecommendationTaken: 0,
      extraPointsForRecommendationGiven: 0,
    },
    selectedCampaign: {},
    campaigns: [],
    companies: [],
    activityPacks: [],
    quizPacks: [],
    notificationPacks: [],
    campaignImages: [],
    loading: false,
  };

  handleAddCampaign = async (campaign, event, isCopy = false) => {
    event.preventDefault();
    try {
      const campaignId = isCopy ? uuid() : campaign.id || uuid();
      const params = {
        campaignId,
        campaignName: campaign.campaignName + (isCopy ? " KOPI" : ""),
        campaignHidden: false,
        campaignCompanies: [],
        nextLeagueStart: parseInt(this.convertUnix(campaign.nextLeagueStart)),
        onboarding: [
          campaign.onboardingTextOne,
          campaign.onboardingTextTwo,
          campaign.onboardingTextThree,
        ],
        timePeriod: parseInt(campaign.timePeriod),
        timePeriodName: campaign.timePeriodName,
        campaignMaxKGCO2: parseInt(campaign.campaignMaxKGCO2),
        usersCanCreateTeams: campaign.usersCanCreateTeams,
        userCreateTeamsDeadlineHours: parseInt(
          campaign.userCreateTeamsDeadlineHours
        ),
        minUsersOnTeam: parseInt(campaign.minUsersOnTeam),
        maxUsersOnTeam: parseInt(campaign.maxUsersOnTeam),
        weekAmount: parseInt(campaign.weekAmount),
        activityPacks: campaign.activityPacks,
        usersCanCompleteYesterdayActivities:
          campaign.usersCanCompleteYesterdayActivities,
        activityListDisabled: campaign.activityListDisabled,
        activityCardsDisabled: campaign.activityCardsDisabled,
        streakRewardPoints: parseInt(campaign.streakRewardPoints),
        streakRewardDayFrequency: parseInt(campaign.streakRewardDayFrequency),
        notificationPack: campaign.notificationPack,
        quizPacks: campaign.quizPacks,
        amountOfQuizzesPerDay: campaign.amountOfQuizzesPerDay,
        campaignType: campaign.campaignType,
        disableMissedActivitiesPopup: campaign.disableMissedActivitiesPopup,
        disableStreaks: campaign.disableStreaks,
        disableQuests: campaign.disableQuests,
        campaignImage: campaign.campaignImage,
        extraPointsForRecommendationTaken:
          parseInt(campaign.extraPointsForRecommendationTaken) || 0,
        extraPointsForRecommendationGiven:
          parseInt(campaign.extraPointsForRecommendationGiven) || 0,
      };

      await axios.post(
        `${config.api.invokeUrl}/campaign/${campaignId}`,
        params
      );

      this.setState({
        campaigns: [
          ...this.state.campaigns,
          {
            ...campaign,
            id: campaignId,
            campaignName: campaign.campaignName + (isCopy ? " KOPI" : ""),
            nextLeagueStart: parseInt(
              this.convertUnix(campaign.nextLeagueStart)
            ),
            extraPointsForRecommendationTaken:
              parseInt(campaign.extraPointsForRecommendationTaken) || 0,
            extraPointsForRecommendationGiven:
              parseInt(campaign.extraPointsForRecommendationGiven) || 0,
          },
        ],
      });
      this.setState({
        newCampaign: {
          campaignName: "",
          id: uuid(),
          onboardingTextOne: "",
          onboardingTextTwo: "",
          onboardingTextThree: "",
          usersCanCreateTeams: false,
          campaignHidden: false,
          usersCanCompleteYesterdayActivities: false,
          userCreateTeamsDeadlineHours: 48,
          minUsersOnTeam: 0,
          maxUsersOnTeam: 0,
          campaignMaxKGCO2: 0,
          nextLeagueStart: 0,
          timePeriod: 0,
          timePeriodName: "week",
          weekAmount: 0,
          activityPacks: { defaultPack: "" },
          activityCardsDisabled: false,
          activityListDisabled: false,
          notificationPack: "",
          quizPacks: { defaultPack: "" },
          amountOfQuizzesPerDay: 0,
          streakRewardPoints: 0,
          streakRewardDayFrequency: 0,
          campaignType: "",
          disableMissedActivitiesPopup: false,
          disableStreaks: false,
          disableQuests: false,
          campaignImage: "",
          extraPointsForRecommendationTaken: 0,
          extraPointsForRecommendationGiven: 0,
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  handleUpdateCampaign = async (campaign, companies) => {
    try {
      const params = {
        campaignId: campaign.id,
        campaignName: campaign.campaignName,
        campaignHidden: campaign.campaignHidden,
        nextLeagueStart: parseInt(this.convertUnix(campaign.nextLeagueStart)),
        currentWeek: campaign.currentWeek,
        usersCanCreateTeams: campaign.usersCanCreateTeams,
        userCreateTeamsDeadlineHours: parseInt(
          campaign.userCreateTeamsDeadlineHours
        ),
        usersCanCompleteYesterdayActivities:
          campaign.usersCanCompleteYesterdayActivities,
        minUsersOnTeam: parseInt(campaign.minUsersOnTeam),
        maxUsersOnTeam: parseInt(campaign.maxUsersOnTeam),
        campaignMaxKGCO2: campaign.campaignMaxKGCO2
          ? parseInt(campaign.campaignMaxKGCO2)
          : 0,
        onboarding: [
          campaign.onboardingTextOne,
          campaign.onboardingTextTwo,
          campaign.onboardingTextThree,
        ],
        timePeriod: parseInt(campaign.timePeriod),
        timePeriodName: campaign.timePeriodName,
        weekAmount: parseInt(campaign.weekAmount),
        activityPacks: campaign.activityPacks,
        activityListDisabled: campaign.activityListDisabled,
        activityCardsDisabled: campaign.activityCardsDisabled,
        streakRewardPoints: parseInt(campaign.streakRewardPoints),
        streakRewardDayFrequency: parseInt(campaign.streakRewardDayFrequency),
        notificationPack: campaign.notificationPack,
        quizPacks: campaign.quizPacks,
        amountOfQuizzesPerDay: campaign.amountOfQuizzesPerDay,
        campaignType: campaign.campaignType,
        disableMissedActivitiesPopup: campaign.disableMissedActivitiesPopup,
        disableStreaks: campaign.disableStreaks,
        disableQuests: campaign.disableQuests,
        campaignImage: campaign.campaignImage,
        extraPointsForRecommendationTaken:
          parseInt(campaign.extraPointsForRecommendationTaken) || 0,
        extraPointsForRecommendationGiven:
          parseInt(campaign.extraPointsForRecommendationGiven) || 0,
      };
      await axios.patch(
        `${config.api.invokeUrl}/campaign/${campaign.id}`,
        params
      );
    } catch (err) {
      console.log(err);
    }

    const updatedCampaigns = [...this.state.campaigns].filter(
      (c) => c.id !== campaign.id
    );
    updatedCampaigns.push({
      ...campaign,
      nextLeagueStart: parseInt(this.convertUnix(campaign.nextLeagueStart)),
    });
    this.setState({ campaigns: updatedCampaigns });
  };

  handleDeleteCampaign = async (id, event) => {
    event.preventDefault();
    if (window.confirm(" Er du sikker?")) {
      try {
        await axios.delete(`${config.api.invokeUrl}/campaign/${id}`);
      } catch (err) {
        console.log(err);
      }
      const updatedCampaigns = [...this.state.campaigns].filter(
        (campaign) => campaign.id !== id
      );
      this.setState({ campaigns: updatedCampaigns });
    }
  };

  fetchCampaigns = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/campaign`);
      const campaigns = res.data;
      campaigns.sort(
        (campaignA, campaignB) =>
          campaignA.campaignHidden > campaignB.campaignHidden
      );
      this.setState({ campaigns: campaigns });
    } catch (err) {
      console.log(err);
    }
  };

  fetchCompanies = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/companies`);
      const companies = res.data;
      this.setState({ companies: companies });
    } catch (err) {
      console.log(err);
    }
  };

  fetchActivityPacks = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/activities/packs/`);
      const activityPacks = res.data;
      this.setState({ activityPacks: activityPacks });
    } catch (err) {
      console.log(err);
    }
  };

  fetchQuizPacks = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/quiz/packs/`);
      const quizPacks = res.data;
      this.setState({ quizPacks: quizPacks });
    } catch (err) {
      console.log(err);
    }
  };

  fetchNotificationPacks = async () => {
    try {
      const res = await axios.get(
        `${config.api.invokeUrl}/notification/packs/`
      );
      const notificationPacks = res.data;
      this.setState({ notificationPacks: notificationPacks });
    } catch (err) {
      console.log(err);
    }
  };

  fetchCampaignImages = async () => {
    try {
      const res = await axios.get(
        `${config.api.invokeUrl}/images?bucketName=${config.s3.campaignImagesBucket}`
      );
      if (res.data?.Contents) {
        const campaignImages = res.data.Contents;
        this.setState({ campaignImages });
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      newCampaign: {
        ...this.state.newCampaign,
        [name]: value,
      },
    });
  }

  convertUnix(dateOrUnix) {
    if (typeof dateOrUnix == "number") {
      const options = {
        timeZone: "Europe/Copenhagen",
        hour: "2-digit",
        minute: "2-digit",
        month: "2-digit",
        year: "numeric",
        day: "2-digit",
      };
      const date = new Date(dateOrUnix);
      return date.toLocaleDateString("da-DK", options);
    } else if (typeof dateOrUnix == "object") {
      return Math.floor(dateOrUnix.getTime() / 1000);
    } else if (typeof dateOrUnix == "string") {
      return Math.floor(new Date(dateOrUnix).getTime() / 1000);
    }
  }

  onActivityPackChange = (e) => {
    const select = e.target;
    const value = select.options[select.selectedIndex].value;

    if (select.id === "activityPackDefault") {
      this.setState({
        newCampaign: {
          ...this.state.newCampaign,
          activityPacks: {
            ...this.state.newCampaign.activityPacks,
            defaultPack: value,
          },
        },
      });
    } else {
      const week = parseInt(select.id.split("activityPack")[1]);
      this.setState({
        newCampaign: {
          ...this.state.newCampaign,
          activityPacks: {
            ...this.state.newCampaign.activityPacks,
            [week]: value,
          },
        },
      });
    }
  };

  onQuizPackChange = (e) => {
    const select = e.target;
    const value = select.options[select.selectedIndex].value;

    if (select.id === "quizPackDefault") {
      this.setState({
        newCampaign: {
          ...this.state.newCampaign,
          quizPacks: {
            ...this.state.newCampaign.quizPacks,
            defaultPack: value,
          },
        },
      });
    } else {
      const week = parseInt(select.id.split("quizPack")[1]);
      this.setState({
        newCampaign: {
          ...this.state.newCampaign,
          quizPacks: {
            ...this.state.newCampaign.quizPacks,
            [week]: value,
          },
        },
      });
    }
  };

  componentDidMount = () => {
    this.fetchAll();
  };

  fetchAll = async () => {
    this.setState({ loading: true });
    let promise = await Promise.all([
      this.fetchCompanies(),
      this.fetchActivityPacks(),
      this.fetchCampaigns(),
      this.fetchNotificationPacks(),
      this.fetchQuizPacks(),
      this.fetchCampaignImages(),
    ]);
    this.setState({ loading: false });
  };

  render() {
    return !this.state.loading ? (
      <>
        <section className="section">
          <div className="container">
            <h1>Kampagne Admin</h1>
            <p className="subtitle is-5">Tilføj og fjern Kampagner</p>
            <br />
            <div className="columns is-multiline is-flex-direction-column">
              <div className="column is-full">
                <form
                  onSubmit={(event) =>
                    this.handleAddCampaign(this.state.newCampaign, event)
                  }
                >
                  <div className="field">
                    <div className="control">
                      <input
                        className="input is-medium"
                        type="text"
                        name="campaignName"
                        placeholder="Indtast navn"
                        required
                        value={this.state.newCampaign.campaignName}
                        onChange={this.handleInputChange}
                      />
                      <label htmlFor="campaignType">Kampagnetype</label>
                      <br />
                      <select
                        className="select is-medium"
                        name="campaignType"
                        id="campaignType"
                        value={this.state.newCampaign.campaignType}
                        onChange={this.handleInputChange}
                      >
                        <option value="Standard">Standard</option>
                        <option value="Mobility">Mobility</option>
                      </select>
                      <br />
                      <input
                        className="is-medium"
                        type="checkbox"
                        id="usersCanCreateTeams"
                        name="usersCanCreateTeams"
                        value={this.state.newCampaign.usersCanCreateTeams}
                        onChange={this.handleInputChange}
                      />
                      <label
                        htmlFor="usersCanCreateTeams"
                        style={{ marginLeft: 5 }}
                      >
                        Brugere kan oprette hold
                      </label>
                      <br />

                      <label htmlFor="userCreateTeamsDeadlineHours">
                        Deadline for holdoprettelse (timer)
                      </label>
                      <input
                        className="input is-medium"
                        type="text"
                        name="userCreateTeamsDeadlineHours"
                        placeholder="Indtast deadline for holdoprettelse (timer)"
                        value={
                          this.state.newCampaign.userCreateTeamsDeadlineHours
                        }
                        onChange={this.handleInputChange}
                      />
                      <br />
                      <input
                        className="is-medium"
                        type="checkbox"
                        id="usersCanCompleteYesterdayActivities"
                        name="usersCanCompleteYesterdayActivities"
                        value={
                          this.state.newCampaign
                            .usersCanCompleteYesterdayActivities
                        }
                        onChange={this.handleInputChange}
                      />
                      <label
                        htmlFor="usersCanCompleteYesterdayActivities"
                        style={{ marginLeft: 5 }}
                      >
                        Brugere kan indtaste for gårsdagen
                      </label>
                      <br />
                      <label htmlFor="minUsersOnTeam">
                        Minimum brugere på hold (0 = ingen minimum)
                      </label>
                      <input
                        className="input is-medium"
                        type="text"
                        name="minUsersOnTeam"
                        placeholder="Minimum bruger på hold"
                        value={this.state.newCampaign.minUsersOnTeam}
                        onChange={this.handleInputChange}
                      />
                      <br />
                      <label htmlFor="maxUsersOnTeam">
                        Max brugere på hold (0 = ingen grænse)
                      </label>
                      <input
                        className="input is-medium"
                        type="text"
                        name="maxUsersOnTeam"
                        placeholder="Max bruger på hold"
                        value={this.state.newCampaign.maxUsersOnTeam}
                        onChange={this.handleInputChange}
                      />
                      <br />
                      <input
                        className="is-medium"
                        type="checkbox"
                        id="activityCardsDisabled"
                        name="activityCardsDisabled"
                        value={this.state.newCampaign.activityCardsDisabled}
                        onChange={this.handleInputChange}
                      />
                      <label
                        htmlFor="activityCardsDisabled"
                        style={{ marginLeft: 5 }}
                      >
                        Deaktiver aktivitetskort
                      </label>
                      <br />
                      <input
                        className="is-medium"
                        type="checkbox"
                        id="activityListDisabled"
                        name="activityListDisabled"
                        value={this.state.newCampaign.activityListDisabled}
                        onChange={this.handleInputChange}
                      />
                      <label
                        htmlFor="activityListDisabled"
                        style={{ marginLeft: 5 }}
                      >
                        Deaktiver liste af aktiviteter
                      </label>
                      <br />
                      <input
                        className="is-medium"
                        type="checkbox"
                        id="disableMissedActivitiesPopup"
                        name="disableMissedActivitiesPopup"
                        value={
                          this.state.newCampaign.disableMissedActivitiesPopup
                        }
                        onChange={this.handleInputChange}
                      />
                      <label
                        htmlFor="disableMissedActivitiesPopup"
                        style={{ marginLeft: 5 }}
                      >
                        Deaktiver popup for missede aktiviteter
                      </label>
                      <br />
                      <input
                        className="is-medium"
                        type="checkbox"
                        id="disableStreaks"
                        name="disableStreaks"
                        value={this.state.newCampaign.disableStreaks}
                        onChange={this.handleInputChange}
                      />
                      <label htmlFor="disableStreaks" style={{ marginLeft: 5 }}>
                        Deaktiver streaks
                      </label>
                      <br />
                      <input
                        className="is-medium"
                        type="checkbox"
                        id="disableQuests"
                        name="disableQuests"
                        value={this.state.newCampaign.disableQuests}
                        onChange={this.handleInputChange}
                      />
                      <label htmlFor="disableQuests" style={{ marginLeft: 5 }}>
                        Deaktiver quests
                      </label>
                      <br />
                      <p>Streak præmiepoint</p>
                      <input
                        className="input is-medium"
                        type="number"
                        name="streakRewardPoints"
                        placeholder="Indtast streak reward points"
                        value={this.state.newCampaign.streakRewardPoints}
                        onChange={this.handleInputChange}
                      />
                      <br />
                      <p>Streak dage præmiefrekvens (0 = ingen præmie)</p>
                      <input
                        className="input is-medium"
                        type="number"
                        name="streakRewardDayFrequency"
                        placeholder="Indtast streak reward day frequency"
                        value={this.state.newCampaign.streakRewardDayFrequency}
                        onChange={this.handleInputChange}
                      />
                      <br />
                      <p>Ekstra point for taget anbefaling</p>
                      <input
                        className="input is-medium"
                        type="number"
                        name="extraPointsForRecommendationTaken"
                        placeholder="Indtast ekstra point for taget anbefaling"
                        value={
                          this.state.newCampaign
                            .extraPointsForRecommendationTaken
                        }
                        onChange={this.handleInputChange}
                      />
                      <br />
                      <p>Ekstra point for givet anbefaling</p>
                      <input
                        className="input is-medium"
                        type="number"
                        name="extraPointsForRecommendationGiven"
                        placeholder="Indtast ekstra point for givet anbefaling"
                        value={
                          this.state.newCampaign
                            .extraPointsForRecommendationGiven
                        }
                        onChange={this.handleInputChange}
                      />
                      <br />
                    </div>

                    <textarea
                      name="onboardingTextOne"
                      className="textarea"
                      placeholder="DANSK Onboarding tekst"
                      value={this.state.newCampaign.onboardingTextOne}
                      onChange={this.handleInputChange}
                    />
                    <textarea
                      name="onboardingTextTwo"
                      className="textarea"
                      placeholder="ENGELSK Onboarding tekst "
                      value={this.state.newCampaign.onboardingTextTwo}
                      onChange={this.handleInputChange}
                    />
                    <textarea
                      name="onboardingTextThree"
                      className="textarea"
                      placeholder="UBRUGT Onboarding tekst "
                      value={this.state.newCampaign.onboardingTextThree}
                      onChange={this.handleInputChange}
                    />
                    <div
                      className="control is-flex"
                      style={{ flexDirection: "column", maxWidth: 250 }}
                    >
                      Ligastart: (Start helst kl 03:00)
                      <input
                        type={"datetime-local"}
                        name={"nextLeagueStart"}
                        onChange={this.handleInputChange}
                        value={this.state.newCampaign.nextLeagueStart}
                      />
                      Liga længde i uger
                      <input
                        type={"text"}
                        name={"weekAmount"}
                        onChange={this.handleInputChange}
                        value={this.state.newCampaign.weekAmount}
                      />
                      <div style={{ flexDirection: "row", display: "flex" }}>
                        <div>
                          Aktiviteter Grundpakke
                          <select
                            className="select is-medium"
                            name={`activityPackDefault`}
                            id={"activityPackDefault"}
                            onChange={this.onActivityPackChange}
                            defaultValue={"def"}
                          >
                            <option id={"def"} value=""></option>
                            {this.state.activityPacks.map((ap, idx) => {
                              return (
                                <option key={ap.id + idx} value={ap.id}>
                                  {ap.packName}
                                </option>
                              );
                            })}
                          </select>
                          {Array.from(
                            {
                              length: parseInt(
                                this.state.newCampaign.weekAmount
                              ),
                            },
                            (_, index) => index + 1
                          ).map((week) => {
                            return (
                              <div key={`activityPack${week}`}>
                                Aktiviteter Uge {week}
                                <select
                                  className="select is-medium"
                                  name={`activityPack${week}`}
                                  id={`activityPack${week}`}
                                  onChange={this.onActivityPackChange}
                                  defaultValue={"def"}
                                >
                                  <option id={"def"} value=""></option>
                                  {this.state.activityPacks.map((ap) => {
                                    return (
                                      <option key={ap.id + week} value={ap.id}>
                                        {ap.packName}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                            );
                          })}
                        </div>

                        <div
                          style={{
                            minWidth: "300px",
                            flexDirection: "column",
                            display: "flex",
                            marginLeft: "10px",
                          }}
                        >
                          Quiz Grundpakke
                          <select
                            className="select is-medium"
                            name={`quizPackDefault`}
                            id={"quizPackDefault"}
                            onChange={this.onQuizPackChange}
                            defaultValue={"def"}
                          >
                            <option id={"def"} value=""></option>
                            {this.state.quizPacks.map((ap, idx) => {
                              return (
                                <option key={ap.id + idx} value={ap.id}>
                                  {ap.packName}
                                </option>
                              );
                            })}
                          </select>
                          {Array.from(
                            {
                              length: parseInt(
                                this.state.newCampaign.weekAmount
                              ),
                            },
                            (_, index) => index + 1
                          ).map((week) => {
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  minWidth: "300px",
                                }}
                                key={`quizPack${week}`}
                              >
                                Quizpakke Uge {week}
                                <select
                                  className="select is-medium"
                                  name={`quizPack${week}`}
                                  id={`quizPack${week}`}
                                  onChange={this.onQuizPackChange}
                                  defaultValue={"def"}
                                >
                                  <option id={"def"} value=""></option>
                                  {this.state.quizPacks.map((ap) => {
                                    return (
                                      <option key={ap.id + week} value={ap.id}>
                                        {ap.packName}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <p>Antal quizzer om dagen</p>
                      <input
                        type={"number"}
                        name={"amountOfQuizzesPerDay"}
                        onChange={this.handleInputChange}
                        value={this.state.newCampaign.amountOfQuizzesPerDay}
                      />
                      Tidsperiode i SEKUNDER
                      <input
                        type={"text"}
                        name={"timePeriod"}
                        onChange={this.handleInputChange}
                        value={this.state.newCampaign.timePeriod}
                      />
                      Tidsperiode navn
                      <select
                        className="select is-medium"
                        type={"text"}
                        name={"timePeriodName"}
                        id={"timePeriodName"}
                        onChange={this.handleInputChange}
                        defaultValue={"week"}
                      >
                        <option value={"week"}>Uge</option>
                        <option value={"day"}>Dag</option>
                        <option value={"round"}>Runde</option>
                      </select>
                      Max kg co2
                      <input
                        type={"text"}
                        name={"campaignMaxKGCO2"}
                        onChange={this.handleInputChange}
                        value={this.state.newCampaign.campaignMaxKGCO2}
                      />
                      <div
                        className="control"
                        style={{ marginTop: 10, marginBottom: 10 }}
                      >
                        Billede:
                        <select
                          name="campaignImage"
                          value={this.state.newCampaign.campaignImage}
                          onChange={this.handleInputChange}
                        >
                          <option value=""></option>
                          {this.state.campaignImages.map((campaignImage) => {
                            return (
                              <option
                                key={campaignImage.Key}
                                value={campaignImage.Key}
                              >
                                {campaignImage.Key}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <>
                        Notifikationspakke
                        <select
                          className="select is-medium"
                          name={`notificationPack`}
                          onChange={this.handleInputChange}
                          defaultValue={""}
                        >
                          <option id={""} value=""></option>
                          {this.state.notificationPacks.map((ap, idx) => {
                            return (
                              <option key={ap.id + idx} value={ap.id}>
                                {ap.packName}
                              </option>
                            );
                          })}
                        </select>
                      </>
                      <button
                        type="submit"
                        className="button is-primary is-medium"
                      >
                        Tilføj
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div className="column">
                <div className="tile is-ancestor ">
                  <div className="tile is-parent flex-wrap">
                    {this.state.campaigns.map((campaign) => (
                      <Campaign
                        handleAddCampaign={this.handleAddCampaign}
                        handleUpdateCampaign={this.handleUpdateCampaign}
                        handleDeleteCampaign={this.handleDeleteCampaign}
                        convertUnix={this.convertUnix}
                        campaign={campaign}
                        companies={this.state.companies}
                        activityPacks={this.state.activityPacks}
                        quizPacks={this.state.quizPacks}
                        notificationPacks={this.state.notificationPacks}
                        campaignImages={this.state.campaignImages}
                        key={campaign.id}
                        isAdmin={true}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    ) : (
      <></>
    );
  }
}
